import { ChevronLeft, ChevronRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { PAGE_SIZE_OPTIONS } from '../documents.constants'

type DocumentsPaginationProps = {
  page: number
  pageSize: number
  pageCount: number
  totalCount: number
  rowsShown: number
  onPageChange: (page: number) => void
  onPageSizeChange: (pageSize: number) => void
}

export const DocumentsPagination = ({
  page,
  pageSize,
  pageCount,
  totalCount,
  rowsShown,
  onPageChange,
  onPageSizeChange,
}: DocumentsPaginationProps) => {
  return (
    <div className="flex items-center justify-between text-sm text-muted-foreground">
      <div className="flex items-center gap-2">
        <Select value={String(pageSize)} onValueChange={(value) => onPageSizeChange(Number(value))}>
          <SelectTrigger className="h-10 w-[110px] rounded-lg bg-background text-sm shadow-sm border border-border">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {PAGE_SIZE_OPTIONS.map((size) => (
              <SelectItem key={size} value={String(size)}>
                Show {size}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <span>
          {rowsShown} of {totalCount} shown
        </span>
      </div>
      <div className="flex items-center gap-0">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
        >
          <ChevronLeft className="h-4 w-4" />
          Prev
        </Button>
        <span className="px-2">
          Page {page} of {pageCount}
        </span>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= pageCount}
        >
          Next
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  )
}
